import { createFileRoute, useSearch } from "@tanstack/react-router";
import { TraumaResponseCheckIn } from "@/components/feelings/TraumaResponseCheckIn";
import { withMemberGate } from "@/lib/with-member-gate";

export const Route = createFileRoute("/trauma-response-check-in")({
  head: () => ({
    meta: [
      { title: "Find My Trauma Response — Recovery Trauma™" },
      {
        name: "description",
        content:
          "A short, gentle check-in to explore which protective response — Fight, Flight, Freeze, Fawn or Shutdown — may be most active for you right now. Self-reflection, not a diagnosis.",
      },
      { property: "og:title", content: "Find My Trauma Response — Recovery Trauma™" },
      {
        property: "og:description",
        content:
          "Take a 2-minute check-in and discover which protective response may be most active right now.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: withMemberGate(TraumaResponseCheckInPage, "Trauma Response Check-In"),
});

function TraumaResponseCheckInPage() {
  const search = useSearch({ strict: false }) as { result?: string };
  const showLatest = search.result === "latest";
  return (
    <main className="min-h-dvh bg-gradient-to-b from-background via-background to-[var(--gold-soft)]/25 px-4 pb-16 pt-6 sm:pt-10">
      <div className="mx-auto max-w-2xl">
        <TraumaResponseCheckIn showLatest={showLatest} />
        <p className="mt-6 text-center text-xs text-muted-foreground">
          Part of the Trauma Response Wheel in Recovery Trauma™ — a self-awareness tool,
          never a diagnostic test.
        </p>
      </div>
    </main>
  );
}
